import translate from '../../../i18n'
import { Modal } from 'antd'

interface IProps {
  open: boolean
  formName: string
  handleCancel: () => void
  handleConfirm: () => void
}

const PrelaunchConfirmModal = (props: IProps) => {
  const { open, formName, handleCancel, handleConfirm } = props

  return (
    <Modal
      title={translate('prelaunchOrganizationForms.confirm')}
      open={open}
      onCancel={handleCancel}
      onOk={handleConfirm}
      destroyOnHidden
      width={800}
    >
      {translate('prelaunchOrganizationForms.confirm.message', { formName: formName })}
    </Modal>
  )
}

export default PrelaunchConfirmModal
